/* eslint-disable max-len */
export default [
  {
    title: 'Pro Resources',
    description: 'Business tools and resources to help Pros manage projects and operations.',
    ctaUrl: 'https://www.homedepot.com/c/pro-resources',
    imageUrl: 'https://dam.thdstatic.com/content/production/bsb8zd9QWkZGxV2nvcsMLw/5G0xy57VqqxOJ2kYjtx5Rw/Original%20file/Create_Lists.png',
  },
  {
    title: 'Pro Articles',
    description: 'Trade articles with how-to guidance and industry insights for Pros.',
    ctaUrl: 'https://www.homedepot.com/c/pro-articles',
    imageUrl: 'https://dam.thdstatic.com/content/production/RtJ1tjgpSuNnE5qwwmtorQ/YtGrJADHIhOgD7ByM3YCUw/Original%20file/Pro-Guides-P6.png',
  },
  {
    title: 'Pro Forecast',
    description: 'Construction industry trends and market forecasts for professional planning.',
    ctaUrl: 'https://www.homedepot.com/c/pro-forecast',
    imageUrl: 'https://dam.thdstatic.com/content/production/XeUUEP0HYb6rZiOCrJwnzQ/S1k9n3oABvq8642xUTmXtw/Original%20file/pro-business-icon-gray-background-pro-business-tools-v1.png',
  },
  {
    title: 'Pro Integrations',
    description: 'Integrated solutions that simplify purchasing and job management.',
    ctaUrl: 'https://www.homedepot.com/c/pro-integrations',
    imageUrl: 'https://dam.thdstatic.com/content/production/aSF5VSM8YbODRbt7AKbyrQ/MFch6-WlQI-JGQfvlDdnTw/Original%20file/Integrations-P7.png',
  },
];